var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"workshopdetails"},[_c('app-Workshopdetails',{attrs:{"workshopId":_vm.ID}}),_c('app-Upcomingworkshop')],1)}
var staticRenderFns = []

export { render, staticRenderFns }